// Shared dark-mode presentational primitives for the Tender Agent prototype
// layout. Every colour is explicit `claudeDark` — nothing here may rely on
// inherited/global theme colour (see ui-redesign-brief.md §7).
import styled from 'styled-components';
import { Button } from 'antd';
import { claudeDark } from '../../tokens';

// The island floats like an antd card: hairline + the warm two-layer shadow.
export const Card = styled.div`
  background: ${claudeDark.surfaceElevated};
  border: 1px solid ${claudeDark.border};
  border-radius: 14px;
  box-shadow: ${claudeDark.shadow.card};
  padding: 24px 26px;
  margin-bottom: 20px;
`;

// The one accent line on the island: the text-safe stop, AA at 11px.
export const Kicker = styled.div`
  font: 600 11px ${claudeDark.fontMono};
  letter-spacing: .12em;
  text-transform: uppercase;
  color: ${claudeDark.accentText};
  margin-bottom: 8px;
`;

export const CardH2 = styled.h2`
  font: 700 19px ${claudeDark.fontDisplay};
  letter-spacing: -0.015em;
  color: ${claudeDark.ink};
  margin: 0 0 10px;
`;

export const Intro = styled.p`
  font: 400 14.5px/1.55 ${claudeDark.fontSans};
  color: ${claudeDark.textSecondary};
  margin: 0 0 20px;
`;

export const FooterBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 26px;
  padding-top: 18px;
  border-top: 1px solid ${claudeDark.border};
`;

export const LeftGroup = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const Ghost = styled(Button)`
  &&& {
    background: transparent;
    border: 1px solid ${claudeDark.borderStrong};
    color: ${claudeDark.textSecondary};
  }
  &&&:hover:not(:disabled) {
    border-color: ${claudeDark.accent};
    color: ${claudeDark.textPrimary};
    background: transparent;
  }
`;

export const Primary = styled(Button)`
  &&& {
    background: ${claudeDark.accent};
    border-color: ${claudeDark.accent};
    color: #fff;
    font-weight: 600;
  }
  &&&:hover:not(:disabled) {
    background: ${claudeDark.accentHover};
    border-color: ${claudeDark.accentHover};
    color: #fff;
  }
  &&&:disabled {
    opacity: .5;
  }
`;

export const ErrorBanner = styled.div`
  background: ${claudeDark.status.failed.bg};
  border: 1px solid ${claudeDark.status.failed.border};
  color: ${claudeDark.status.failed.text};
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 18px;
  font: 500 13px ${claudeDark.fontSans};
`;
